import PropTypes from 'prop-types';
import { GraphQLProvider as RealGraphQLProvider } from "./graphql";
var USE_AUTH;
export var useAuth = function useAuth() {
  return USE_AUTH();
};

var RedwoodProvider = function RedwoodProvider(_ref) {
  var _ref$auth = _ref.auth,
      auth = _ref$auth === void 0 ? {} : _ref$auth,
      children = _ref.children;
  var _auth$AuthProvider = auth.AuthProvider,
      AuthProvider = _auth$AuthProvider === void 0 ? React.Fragment : _auth$AuthProvider,
      _auth$GraphQLProvider = auth.GraphQLProvider,
      GraphQLProvider = _auth$GraphQLProvider === void 0 ? RealGraphQLProvider : _auth$GraphQLProvider,
      _auth$useAuth = auth.useAuth,
      useAuth = _auth$useAuth === void 0 ? function () {
    return {};
  } : _auth$useAuth;
  USE_AUTH = useAuth;
  return React.createElement(AuthProvider, null, React.createElement(GraphQLProvider, null, children));
};

RedwoodProvider.propTypes = {
  auth: PropTypes.shape({
    AuthProvider: PropTypes.func.isRequired,
    useAuth: PropTypes.func.isRequired,
    GraphQLProvider: PropTypes.func.isRequired
  })
};
export default RedwoodProvider;